export class TableDataModel {
	sk: string; //MODEL_objectType
	name: string;
	columns: TableColumn[] = [];

	public constructor(init?: Partial<TableDataModel>) {
		Object.assign(this, init);

		this.sk && (this.name = this.sk.replace('MODEL_', ''));
	}
}

export class TableColumn {
	displayName: string;
	display: boolean;
	sortProperty: string;
	filterType: TableColumnFilterType;
	filterProperty: string;
	filterSelectArray: any;
	filterSelectMatchType: TableColumnFilterMatchType;
	dataObjectDisplayProperty: string;
	dataObjectValueProperty: string;
	dataObjectDisplayIndex: number;
	dataObjectArray: boolean;
	dataProperty: string;
	sortOrder: number;
	imageView: boolean;
	imagePrefix: string;
	imageMeta: string;

	public constructor(init?: Partial<TableColumn>) {
		Object.assign(this, init);
	}
}

export enum TableColumnFilterType {
	TEXT = 'text',
	NUMBER = 'numeric',
	SELECT = 'select',
}

export enum TableColumnFilterMatchType {
	STARTSWITH = 'startsWith',
	CONTAINS = 'contains',
	ENDSWITH = 'endsWith',
	EQUALS = 'equals',
	NOTEQUALS = 'notEquals',
	LESSTHAN = 'lt',
	LESSTHANEQUALS = 'lte',
	GREATERTHAN = 'gt',
	GREATERTHANEQUALS = 'gte',
	IS = 'is',
	ISNOT = 'isNot',
	BEFORE = 'before',
	AFTER = 'after',
}
